import { render, staticRenderFns } from "./ValidationErrorsModal.vue?vue&type=template&id=20e00686&"
import script from "./ValidationErrorsModal.vue?vue&type=script&lang=js&"
export * from "./ValidationErrorsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports